import {Component, Input} from '@angular/core';
import {NgSwitch, NgSwitchCase} from '@angular/common';

@Component({
  selector: 'app-lp-icon',
  imports: [
    NgSwitch,
    NgSwitchCase
  ],
  templateUrl: './lp-icon.component.html'
})
export class LpIconComponent {

  @Input()
  icon: string;

  @Input()
  color: string
}
